
export default function Panel_Cases_Create_P()
{
  return (
    <div>
      <h1>ایجاد فایل</h1>
    </div>
  );
}
